const UzbekistánSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112721)">
      <path
        d="M0.944375 13.9126C0.331719 15.832 -7.81112e-05 17.8767 1.37933e-08 19.9993C-7.81112e-05 22.122 0.331797 24.1669 0.944453 26.0863L20 26.9559L39.0555 26.0864C39.6681 24.167 40.0001 22.122 40.0001 19.9995C40 17.8768 39.6682 15.832 39.0555 13.9125L20 13.043L0.944375 13.9126Z"
        fill="#F0F0F0"
      />
      <path
        d="M39.0557 13.9125L20.0001 13.043L0.944492 13.9125C0.76293 14.4816 0.606602 15.0618 0.475586 15.6516H39.5243C39.3935 15.0617 39.2372 14.4814 39.0557 13.9125Z"
        fill="#D80027"
      />
      <path
        d="M0.475586 24.3486C0.606445 24.9385 0.762774 25.5186 0.944336 26.0877L0.946211 26.0878L19.9998 26.9573L39.0554 26.0878C39.2369 25.5187 39.3932 24.9385 39.5242 24.3486H0.475586Z"
        fill="#D80027"
      />
      <path
        d="M20.0003 40C28.9234 40 36.4805 34.156 39.0558 26.0869H0.944824C3.52022 34.1559 11.0774 40 20.0003 40Z"
        fill="#6DA544"
      />
      <path
        d="M19.9999 7.83288e-10C11.0769 7.81258e-05 3.51988 5.84406 0.944336 13.913L39.0554 13.9131C36.4801 5.84398 28.923 -7.81242e-05 19.9999 7.83288e-10Z"
        fill="#338AF3"
      />
      <path
        d="M9.13992 8.26355C9.13992 6.39035 10.4564 4.82551 12.2145 4.4416C11.9443 4.38254 11.6639 4.35059 11.3759 4.35059C9.21484 4.35059 7.46289 6.10246 7.46289 8.26363C7.46289 10.4248 9.21469 12.1767 11.3759 12.1767C11.6639 12.1767 11.9442 12.1446 12.2145 12.0857C10.4565 11.7016 9.13992 10.1368 9.13992 8.26355Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.5275 10.041L14.7923 10.8562H15.6495L14.9561 11.3602L15.2209 12.1754L14.5275 11.6716L13.8339 12.1754L14.0988 11.3602L13.4053 10.8562H14.2625L14.5275 10.041Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.2627 10.041L17.5276 10.8562H18.3848L17.6912 11.3602L17.9562 12.1754L17.2627 11.6716L16.5691 12.1754L16.8341 11.3602L16.1406 10.8562H16.9977L17.2627 10.041Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9991 10.041L20.264 10.8562H21.1212L20.4277 11.3602L20.6926 12.1754L19.9991 11.6716L19.3055 12.1754L19.5705 11.3602L18.877 10.8562H19.7342L19.9991 10.041Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.7355 10.041L23.0004 10.8562H23.8575L23.1641 11.3602L23.429 12.1754L22.7355 11.6716L22.0419 12.1754L22.3069 11.3602L21.6133 10.8562H22.4705L22.7355 10.041Z"
        fill="#F0F0F0"
      />
      <path
        d="M25.4707 10.041L25.7356 10.8562H26.5928L25.8993 11.3602L26.1643 12.1754L25.4707 11.6716L24.7771 12.1754L25.0421 11.3602L24.3486 10.8562H25.2057L25.4707 10.041Z"
        fill="#F0F0F0"
      />
      <path
        d="M17.2627 7.19629L17.5276 8.01145H18.3848L17.6912 8.51543L17.9562 9.33059L17.2627 8.82676L16.5691 9.33059L16.8341 8.51543L16.1406 8.01145H16.9977L17.2627 7.19629Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9991 7.19629L20.264 8.01145H21.1212L20.4277 8.51543L20.6926 9.33059L19.9991 8.82676L19.3055 9.33059L19.5705 8.51543L18.877 8.01145H19.7342L19.9991 7.19629Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.7355 7.19629L23.0004 8.01145H23.8575L23.1641 8.51543L23.429 9.33059L22.7355 8.82676L22.0419 9.33059L22.3069 8.51543L21.6133 8.01145H22.4705L22.7355 7.19629Z"
        fill="#F0F0F0"
      />
      <path
        d="M25.4707 7.19629L25.7356 8.01145H26.5928L25.8993 8.51543L26.1643 9.33059L25.4707 8.82676L24.7771 9.33059L25.0421 8.51543L24.3486 8.01145H25.2057L25.4707 7.19629Z"
        fill="#F0F0F0"
      />
      <path
        d="M19.9991 4.35059L20.264 5.1659H21.1212L20.4277 5.66973L20.6926 6.48504L19.9991 5.98121L19.3055 6.48504L19.5705 5.66973L18.877 5.1659H19.7342L19.9991 4.35059Z"
        fill="#F0F0F0"
      />
      <path
        d="M22.7355 4.35059L23.0004 5.1659H23.8575L23.1641 5.66973L23.429 6.48504L22.7355 5.98121L22.0419 6.48504L22.3069 5.66973L21.6133 5.1659H22.4705L22.7355 4.35059Z"
        fill="#F0F0F0"
      />
      <path
        d="M25.4707 4.35059L25.7356 5.1659H26.5928L25.8993 5.66973L26.1643 6.48504L25.4707 5.98121L24.7771 6.48504L25.0421 5.66973L24.3486 5.1659H25.2057L25.4707 4.35059Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112721">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UzbekistánSvg;
